/** @format */

export const personGroupTypesModule = 'sis-components.constant.personGroupTypes';

(function () {
    angular.module(personGroupTypesModule, []).constant('PersonGroupTypes', {
        TARGET_STUDENT_GROUP: 'TARGET_STUDENT_GROUP',
        TUTORING_STUDENT_GROUP: 'TUTORING_STUDENT_GROUP',
    });
})();
